@if (layers().length) {
  <div
    (click)="closeCurrentPanel($event)"
    class="side-panel__overlay"
    [class.second-layer]="layers().length > 1"
    [ngStyle]="{ 'z-index': layers().length * zIndexMultiplier - 2 }"
  ></div>
}

@if (showNavigationControls()) {
  <!-- Stacked panel indicator - separate element to prevent flickering during navigation -->
  <div
    class="stacked-panel-indicator"
    [style.z-index]="layers().length * zIndexMultiplier - 1"
    [style.left]="'calc(' + getPanelOffset() + ' - 16px)'"
  ></div>
  <div class="panel-navigation" [style.z-index]="(layers().length + 1) * zIndexMultiplier">
    <button
      class="panel-navigation__button"
      [class.panel-navigation__button--disabled]="!canNavigateForward()"
      [disabled]="!canNavigateForward()"
      [matTooltip]="canNavigateForward() ? 'Go forward' : null"
      [matTooltipShowDelay]="0"
      matTooltipPosition="left"
      (click)="navigateForward($event)"
    >
      <lucide-icon name="arrow-right" [size]="18" [strokeWidth]="2" />
    </button>
    <button
      class="panel-navigation__button"
      [class.panel-navigation__button--disabled]="!canNavigateBack()"
      [disabled]="!canNavigateBack()"
      [matTooltip]="canNavigateBack() ? 'Go back' : null"
      [matTooltipShowDelay]="0"
      matTooltipPosition="left"
      (click)="navigateBack($event)"
    >
      <lucide-icon name="arrow-left" [size]="18" [strokeWidth]="2" />
    </button>
    <button
      class="panel-navigation__button panel-navigation__button--close"
      matTooltip="Close all panels"
      [matTooltipShowDelay]="0"
      matTooltipPosition="left"
      (click)="closeAllPanels($event)"
    >
      <lucide-icon name="x" [size]="18" [strokeWidth]="2" />
    </button>
  </div>
}

@for (layer of panelLayers(); track getLayerTrackId(layer); let last = $last) {
  <div
    #panelContent
    [style.z-index]="getPanelZIndex($index)"
    [style.left]="getPanelOffset()"
    [class.is-resizing]="isResizing()"
    [class.is-stacked]="$index !== currentPanelIndex()"
    [class.is-current]="$index === currentPanelIndex()"
    class="content__panel"
  >
    @if ($index === currentPanelIndex()) {
      <div class="resize-handle" (mousedown)="onResizeStart($event)">
        <lucide-icon name="grip-vertical" class="resize-handle__icon" [size]="16" [strokeWidth]="2" />
      </div>
    }
    <div class="content__panel-component">
      <ng-container *ngComponentOutlet="layer.component; inputs: layer.inputBindings" />
    </div>
    @if (layer.keyboardShortcuts) {
      <div class="shortcuts" [innerHTML]="layer.keyboardShortcuts"></div>
    }
    <img class="close-button" src="assets/images/common/cancel.svg" (click)="closeCurrentPanel($event)" alt="close" />
  </div>
}
